import { CounterBadge } from '@wix/design-system';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { selectUnreadCount } from '../../../common/selectors/chat';
import { headerActionsDataHooks } from './HeaderActions.dataHooks';
import s from './styles.scss';

export const MessageNotificationCounter: FC = () => {
  const unreadCount = useSelector(selectUnreadCount);

  if (unreadCount === 0) {
    return null;
  }

  return (
    <div
      className={s.messageNotificationCounter}
      data-hook={headerActionsDataHooks.newMessageNotificationCounter({
        count: unreadCount,
      })}
    >
      <CounterBadge skin="danger" size="small">
        {unreadCount}
      </CounterBadge>
    </div>
  );
};
